/* PDP Mobile — Sticky Add-to-Cart Bar

 * Product data comes from Liquid (snippets/sticky-atc-bar.liquid).

 * This script only handles: visibility, drawer guard, viewport offset.

 */

(function () {
    "use strict";

    var mq = window.matchMedia("(max-width: 767px)");
    var bar = document.querySelector("[data-sticky-atc]");
    if (!bar) return;
    var visible = false;
    var drawerOpen = false;

    /* TODO DEV: check the selector against the buy-buttons snippet that actually
  
       renders and adjust if necessary (see §2). */

    function nativeAtcBtn() {
        return (document.querySelector('buy-buttons.buy-buttons') || document.querySelector('buy-buttons:not(product-quick-add buy-buttons) button[type="submit"]') || document.querySelector('buy-buttons button[type="submit"]')
        );
    }

    function nativeAtc() {
        return (document.querySelector('buy-buttons:not(product-quick-add buy-buttons) button[type="submit"]') || document.querySelector('buy-buttons button[type="submit"]')
        );
    }

    function isDrawerOpen() {
        var d = document.querySelector("cart-drawer, .cart-drawer");
        return !!(d && d.hasAttribute("open"));
    }

    /* Offset for the browser toolbar when shown (Google app / Safari) */

    var vvQueued = false;

    function syncViewport() {
        vvQueued = false;
        var vv = window.visualViewport;
        if (!vv) return;
        var gap = window.innerHeight - vv.height - vv.offsetTop;

        bar.style.setProperty("--sticky-atc-vv", Math.max(0, Math.round(gap)) + "px");
    }

    function queueSync() {
        if (vvQueued) return;
        vvQueued = true;
        requestAnimationFrame(syncViewport);
    }

    function show() {
        if (visible || drawerOpen || !mq.matches) return;
        visible = true;
        bar.hidden = false;
        requestAnimationFrame(function () {bar.classList.add("is-visible");});
        document.body.classList.add("sticky-atc-open");
        syncViewport();
    }

    function hide() {
        if (!visible) return;
        visible = false;
        bar.classList.remove("is-visible");
        document.body.classList.remove("sticky-atc-open");
    }

    /* Visibility: show the bar as soon as the native ATC button has scrolled
  
       up out of the viewport. */

    var io = null;

    function observeAtc() {
        var atc = nativeAtcBtn();
        if (!atc) return false;
        if (io) io.disconnect();

        io = new IntersectionObserver(
            function (entries) {
                var e = entries[0];

                if (!e.isIntersecting && e.boundingClientRect.bottom < 0) show();
                else hide();
            },
            { threshold: 0, rootMargin: "30px 0px 0px 0px" },
        );

        io.observe(atc);
        return true;
    }

    function watchDrawer() {
        var obs = new MutationObserver(function () {
            var open = isDrawerOpen();
            if (open === drawerOpen) return;
            drawerOpen = open;

            if (open) {
                hide();
            } else {
                requestAnimationFrame(function () {
                    syncViewport();
                    observeAtc();
                });
            }
        });

        var d = document.querySelector("cart-drawer, .cart-drawer");
        if (d) obs.observe(d, { attributes: true, attributeFilter: ["open"] });
        obs.observe(document.body, { childList: true, subtree: false });
    }

    bar.querySelector("[data-sticky-atc-btn]").addEventListener("click", function () {
            if (bar.dataset.mode === "atc") {
                var atc = nativeAtc();

                /* .click() on the native button instead of form.submit():
        
                 this keeps the entire theme logic (opening the drawer, analytics,
        
                 tracking pixels) active and unchanged. */

                if (atc && !atc.disabled) {
                    atc.click();
                    return;
                }
            }

            var target = document.querySelector(
                "variant-picker, .product-info__variant-picker, .variant-picker, " +
                ".product__variants, buy-buttons:not(product-quick-add buy-buttons)",
            );

            if (target)
                target.scrollIntoView({ behavior: "smooth", block: "center" });
        });

    /* Update the price on variant change.
  
       TODO DEV: check the event name against the theme version (see §2). */

    document.addEventListener("variant:change", function (e) {
        var el = bar.querySelector("[data-sticky-atc-price]");
        var v = e.detail && (e.detail.variant || e.detail);

        if (el && v && v.price != null) {
            el.textContent = (v.price / 100).toLocaleString("de-DE", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 0,
            });
        }
    });

    function init() {
        if (!mq.matches) {
            hide();
            return;
        }

        drawerOpen = isDrawerOpen();

        if (!observeAtc()) {
            var tries = 0;
            var t = setInterval(function () {
                if (observeAtc() || ++tries > 20) clearInterval(t);
            }, 250);
        }

        watchDrawer();

        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", queueSync);
            window.visualViewport.addEventListener("scroll", queueSync);
        }

        syncViewport();
    }

    mq.addEventListener("change", function () {
        hide();
        init();
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
